export enum AppPage {
    FileEmail,
    FileMultipleEmail,
    FileAsIssue,
    FileAsSubmittal,
    FileAsRfi,
    SendAndFile,
    ProjectEmail,
}
